/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["orders-new-order .card-divider{border-bottom:1px solid #e0e0e0}orders-new-order .mat-expansion-panel-header-title{margin-right:0}orders-new-order .mat-expansion-panel-header-description{justify-content:flex-end;margin-right:0;align-items:flex-end}@media screen and (max-width:599px){orders-new-order .mat-expansion-panel-header-description{font-size:12px}}orders-new-order .ngx-avatar{cursor:pointer}"];
export { styles as styles };
